import React from "react";
import "./EmissionChoice.scss";
import { Button } from "../Button/Button";

interface IProps {
    visible: boolean;
    setEmissionState: (value: boolean) => void;
}

export function EmissionChoice({ visible, setEmissionState }: IProps) {
    return (
        <div className={`emission-choice-wrapper ${visible ? 'visible': ''}`}>
            <span>Start with the</span>
            <span className="in-your-face">EMISSION STATE</span>
            <div className="buttons-wrapper">
                <Button variant={'yellow'} onClick={() => setEmissionState(true)}>AS IT IS</Button>
                <Button variant={'yellow'} onClick={() => setEmissionState(false)}>IMPROVED</Button>
                <div className="pulse-wrapper">
                    <div className="pulse" />
                    <div className="pulse" />
                    <div className="pulse" />
                </div>
            </div>
        </div>
    )
}
